// ============================================================================
// REPOSITORY: SimuladoEngineRepository — bookmarks e resultados de exames
// ARQUIVO: src/services/SimuladoEngineRepository.js
// ============================================================================

import { collection, doc, addDoc, setDoc, deleteDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

const DEFAULT_APP_ID = 'portalrda-f312d';

export async function getBookmarkExists(userId, qId, appId = DEFAULT_APP_ID) {
  const ref = doc(db, ...FS.userBookmarks(appId, userId), qId);
  const snap = await getDoc(ref);
  return snap.exists();
}

export async function deleteBookmark(userId, qId, appId = DEFAULT_APP_ID) {
  const ref = doc(db, ...FS.userBookmarks(appId, userId), qId);
  await deleteDoc(ref);
}

export async function saveBookmark(userId, qId, data, appId = DEFAULT_APP_ID) {
  const ref = doc(db, ...FS.userBookmarks(appId, userId), qId);
  await setDoc(ref, {
    ...data,
    savedAt: serverTimestamp(),
  });
}

export async function saveExamResult(userId, data, appId = DEFAULT_APP_ID) {
  const ref = collection(db, ...FS.userExamResults(appId, userId));
  await addDoc(ref, {
    ...data,
    createdAt: serverTimestamp(),
  });
}
